import api from './axios';

export const getFitTests = (params = {}) =>
  api.get('/fit-tests', { params }).then((r) => r.data);

export const getFitTestsPaginado = (params = {}) =>
  api.get('/fit-tests', { params }).then((r) => ({
    items: r.data,
    total: parseInt(r.headers['x-total-count'] || '0', 10),
  }));

export const getFitTest = (id) =>
  api.get(`/fit-tests/${id}`).then((r) => r.data);

export const createFitTest = (data) =>
  api.post('/fit-tests', data).then((r) => r.data);

export const updateFitTest = (id, data) =>
  api.patch(`/fit-tests/${id}`, data).then((r) => r.data);

export const reagendarFitTest = (id, data) =>
  api.patch(`/fit-tests/${id}/reagendar`, data).then((r) => r.data);

export const standbyFitTest = (id) =>
  api.patch(`/fit-tests/${id}/standby`).then((r) => r.data);

export const cancelarFitTest = (id) =>
  api.patch(`/fit-tests/${id}/cancelar`).then((r) => r.data);

export const confirmarFitTest = (id, id_equipamento = null) =>
  api.patch(`/fit-tests/${id}/confirmar`, id_equipamento ? { id_equipamento } : {}).then((r) => r.data);

export const recusarFitTest = (id, data) =>
  api.patch(`/fit-tests/${id}/recusar`, data).then((r) => r.data);
